module.exports = __webpack_public_path__ + "img/img6.fe4c12ca.jpg";